module.exports = __webpack_public_path__ + "static/media/CV_LuisBoscan_EN_v2.c39d2f69.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/docs/CV_LuisBoscan_EN_v2.pdf
// module id = 757
// module chunks = 0